export enum SearchTabEnum {
    FirstTab,
    SecondTab,
}
